// This file contains event handler functions for the Film Development Wizard

function handlePrintChoice(choice) {
  userSelections['step4'] = 'Yes';
  const currentElement = document.getElementById('step4');
  if (currentElement) {
    currentElement.classList.remove('active');
    const buttons = currentElement.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent.includes('Yes')) {
        button.classList.add('selected');
      }
    });
  }
  currentStep = 41;
  document.getElementById('step4a').classList.add('active');
  updateNavigation();
}

function handlePrintMaterial(material) {
  userSelections['step4_material'] = material;
  const currentElement = document.getElementById('step4a');
  if (currentElement) {
    currentElement.classList.remove('active');
    const buttons = currentElement.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent === material) {
        button.classList.add('selected');
      }
    });
  }
  currentStep = 42;
  document.getElementById('step4b').classList.add('active');
  updateNavigation();
}

function handlePrintQuantity(quantity) {
  userSelections['step4_quantity'] = quantity;
  const currentElement = document.getElementById('step4b');
  if (currentElement) {
    currentElement.classList.remove('active');
    const buttons = currentElement.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent === quantity) {
        button.classList.add('selected');
      }
    });
  }
  currentStep = 5;
  document.getElementById('step5').classList.add('active');
  
  // Update shipping options now that we are moving to step 5
  updateShippingOptions();
  
  updateNavigation();
}

function handleShippingChoice(choice) {
  userSelections['step5'] = choice;
  const currentElement = document.getElementById('step5');
  if (currentElement) {
    currentElement.classList.remove('active');
    const buttons = currentElement.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent.includes(choice)) {
        button.classList.add('selected');
      }
    });
  }
  currentStep = 51;
  document.getElementById('step5a').classList.add('active');
  updateNavigation();
}

function handleShippingSubOption(subOption) {
  userSelections['step5_shipping'] = subOption;
  const currentElement = document.getElementById('step5a');
  if (currentElement) {
    currentElement.classList.remove('active');
    const buttons = currentElement.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent.includes(subOption)) {
        button.classList.add('selected');
      }
    });
  }
  currentStep = 6; // Go to summary
  showSummary();
  updateNavigation();
}

function submitChoices() {
  const notes = document.getElementById('orderNotes').value;
  const errorMessageElement = document.getElementById('error-message');
  const summarySection = document.getElementById('summarySection');
  
  errorMessageElement.style.display = 'none';
  summarySection.style.display = 'block';
  
  // Update the selections list in the summary
  updateSelectionsList();
  
  console.log("==== Starting submitChoices function ====");

  // Get the selected film type, handling disposable cameras
  let selectedFilmType = userSelections['step1'];
  const originalFilmType = selectedFilmType;
  
  // Map Disposable Camera to 35mm for variant lookup
  if (selectedFilmType === 'Disposable Camera') {
    selectedFilmType = '35mm';
    console.log("Mapping Disposable Camera to 35mm for variant lookup");
  }
  
  // Get the processing type and resolution
  const processingType = userSelections['step2'];
  const scanMethod = 'Scan and Email'; // Always email scanning now
  const resolution = userSelections['step3'];
  
  console.log('User Selections:', JSON.stringify(userSelections, null, 2));
  console.log('Processing Type:', processingType);
  console.log('Scan Method:', scanMethod);
  console.log('Resolution:', resolution);
  
  // Build the variant key and look up the variant ID
  const filmKey = buildVariantKey(selectedFilmType, processingType, scanMethod, resolution);
  
  console.log('Selected Film Type:', selectedFilmType);
  console.log('Original Film Type:', originalFilmType);
  console.log('Constructed Film Key:', filmKey);
  
  const filmVariantId = variantMapping[selectedFilmType]?.[filmKey];
  console.log('Found Film Variant ID:', filmVariantId);
  
  if (!filmVariantId) {
    errorMessageElement.textContent = "Error: No matching film variant found. Please check your selections.";
    errorMessageElement.style.display = 'block';
    console.error(`Failed to find variant with key "${filmKey}" for film type "${selectedFilmType}"`);
    return;
  }

  const filmOrder = {
    id: filmVariantId,
    quantity: 1,
    properties: {
      "Film Type": originalFilmType || "",
      "Notes": notes || "",
      "Shipping Type": getShippingLabel() || "",
    },
  };

  // Add Print Preference to properties
  if (userSelections['step4']) {
    filmOrder.properties["Print Preference"] = userSelections['step4'];
  }

  let printOrder = null;
  if (userSelections['step4'] === 'Yes' && 
      userSelections['step4_material'] && userSelections['step4_quantity']) {
    const printKey = `${userSelections['step4_material']}_${userSelections['step4_quantity']}`.replace(/\s+/g, '_');
    const printVariantId = variantMapping['Prints'][printKey];

    if (printVariantId) {
      printOrder = {
        id: printVariantId,
        quantity: 1,
        properties: {
          "Print Type": userSelections['step4_material'],
          "Quantity": userSelections['step4_quantity'],
        },
      };
    } else {
      errorMessageElement.textContent = "Error: No matching print variant found. Please check your print selections.";
      errorMessageElement.style.display = 'block';
      return;
    }
  }

  // Handle shipping options as a separate variant
  let shippingOrder = null;

  // If user selected prints, automatically add "Ship back with my prints" variant
  if (userSelections['step4'] === 'Yes') {
    shippingOrder = {
      id: 45089730560165, // "Ship back with my prints" variant
      quantity: 1
    };
  } 
  // Check for shipping sub-option if "Send Negatives Back" was selected
  else if (userSelections['step5_shipping']) {
    switch (userSelections['step5_shipping']) {
      case 'Ship back my Negatives once processed':
        shippingOrder = {
          id: 45089942503589, // "Ship back my Negatives once processed" variant
          quantity: 1
        };
        break;
      case 'Ship back all my past negatives':
        shippingOrder = {
          id: 45089730527397, // "Ship back all my past negatives" variant
          quantity: 1
        };
        break;
      case 'Ship with items in my cart':
        shippingOrder = {
          id: 45089730494629, // "Ship with items in my cart" variant
          quantity: 1
        };
        break;
      default:
        // No error needed, just log and continue without a shipping variant
        console.warn("Unknown shipping sub-option:", userSelections['step5_shipping']);
        break;
    }
  }
  // Otherwise, use selection from step 5
  else if (userSelections['step5']) {
    switch (userSelections['step5']) {
      case 'Hold Negatives':
        shippingOrder = {
          id: 45089737932965, // "Hold onto my Negatives" variant
          quantity: 1
        };
        break;
      case 'Pickup In-Store':
      case 'Destroy / Bin my Negatives':
        // No shipping item needed for these options
        break;
      default:
        // No error needed, just log and continue without a shipping variant
        console.warn("Unknown shipping option:", userSelections['step5']);
        break;
    }
  }

  // First check if shipping variant already exists in the cart before adding
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Check if a shipping variant already exists in the cart
      const existingShipping = cart.items.some(item => {
        return [
          45089730560165, // Ship back with my prints
          45089942503589, // Ship back my Negatives once processed
          45089730527397, // Ship back all my past negatives
          45089730494629, // Ship with items in my cart
          45089737932965  // Hold onto my Negatives
        ].includes(item.variant_id);
      });
        
      const cartItems = [filmOrder];
      if (printOrder) cartItems.push(printOrder);
      if (shippingOrder && !existingShipping) cartItems.push(shippingOrder);

      // Now add to cart
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems }),
      });
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Success:', data);
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error:', error);
      errorMessageElement.textContent = 'Failed to add to cart. Please try again.';
      errorMessageElement.style.display = 'block';
    });
}

// Function to set up shipping step based on film type
function updateShippingStep() {
  const filmType = userSelections['step1'] || '35mm';
  const shippingStep = document.getElementById('step6');
  const shippingButtons = shippingStep.querySelectorAll('button');
  
  // Reset all buttons first
  shippingButtons.forEach(button => {
    button.disabled = false;
    button.style.display = 'block';
    button.style.opacity = "1";
    button.style.cursor = "pointer";
  });
  
  // All film types have shipping included in variant IDs
  // We still show all options for selection, and they modify the variant ID directly
  
  // Add an explanatory note at the top of step 6
  const explanationEl = document.getElementById('shipping-explanation');
  if (!explanationEl) {
    const explanation = document.createElement('p');
    explanation.id = 'shipping-explanation';
    explanation.innerHTML = 'Please select how you would like your negatives handled:';
    explanation.style.marginBottom = '15px';
    shippingStep.insertBefore(explanation, shippingStep.firstChild);
  }
  
  // Make sure "Send Negatives Back" options are properly labeled
  shippingButtons.forEach(button => {
    if (button.textContent.includes('Ship')) {
      button.textContent = button.textContent.replace('Ship', 'Send Negatives Back');
    }
  });
  
  console.log('Shipping step updated for film type:', filmType);
  
  // If scan method is 'USB', disable digital delivery options
  const scanMethod = userSelections['step3'];
  if (scanMethod === 'USB') {
    shippingButtons.forEach(button => {
      if (button.textContent.includes('Email') || 
          button.textContent.includes('Download')) {
        button.disabled = true;
        button.style.opacity = "0.5";
        button.style.cursor = "not-allowed";
      }
    });
  }
  
  // If scan method is 'Email', make Email option default
  if (scanMethod === 'Email') {
    // Find and pre-select the Email option if it exists
    const emailButton = Array.from(shippingButtons).find(btn => btn.textContent.includes('Email'));
    if (emailButton) {
      emailButton.disabled = false;
      emailButton.style.opacity = "1";
      emailButton.style.cursor = "pointer";
    }
  }

  updateNavigation();
}

// Verification function to check processing type availability
function verifyProcessingTypeAvailability() {
  console.log("Verifying processing type availability...");
  
  // Check if we're at step 2 (processing type selection)
  if (currentStep !== 2) return;
  
  let filmType = userSelections['step1'];
  const originalFilmType = userSelections['step1_original'];
  
  // If we have an original film type, check if it's Disposable Camera
  if (originalFilmType === 'Disposable Camera') {
    console.log("Found Disposable Camera as original selection");
    filmType = '35mm'; // Force normalize to 35mm
  }
  
  if (!filmType) return;
  
  console.log(`Current film type: ${filmType} (Original: ${originalFilmType || 'None'})`);
  
  // Normalize film type for verification (treat Disposable Camera as 35mm)
  const normalizedFilmType = filmType;
  console.log(`Normalized film type for verification: ${normalizedFilmType}`);
  
  // Get the expected available processing types for this film type
  let availableTypes;
  switch(normalizedFilmType) {
    case "35mm":
      availableTypes = ["Color (C-41)", "Black-and-White", "E-6 (Slide Film)", "Cross Processing", "ECN-2 (Cinematic Film)"];
      break;
    case "120":
      availableTypes = ["Color (C-41)", "Black-and-White", "Cross Processing"];
      break;
    case "110":
    case "APS":
      availableTypes = ["Color (C-41)", "Black-and-White"];
      break;
    default:
      availableTypes = ["Color (C-41)", "Black-and-White"];
  }
  
  console.log("Available types:", availableTypes);
  
  // Check button states
  const step2Buttons = document.querySelectorAll('#step2 button');
  step2Buttons.forEach(button => {
    const processingType = button.getAttribute('data-processing-type');
    const isDisabled = button.disabled;
    const opacity = button.style.opacity;
    
    console.log(`Processing type: ${processingType}, Disabled: ${isDisabled}, Opacity: ${opacity}`);
    
    // Skip if processing type is null or empty
    if (!processingType) {
      // If null, it should be disabled
      if (!isDisabled) {
        console.error(`ERROR: Button without processing type should be disabled`);
        
        // Fix it automatically
        button.disabled = true;
        button.style.opacity = "0.5";
        button.style.cursor = "not-allowed";
        button.classList.add('disabled-option');
        console.log(`Fixed: Disabled button without processing type`);
      }
      return;
    }
    
    // Check if the button's state matches expected availability
    const shouldBeEnabled = availableTypes.includes(processingType);
    if (shouldBeEnabled && isDisabled) {
      console.error(`ERROR: ${processingType} should be enabled for ${normalizedFilmType} film but isn't`);
    } else if (!shouldBeEnabled && !isDisabled) {
      console.error(`ERROR: ${processingType} should be disabled for ${normalizedFilmType} film but isn't`);
      
      // Fix it automatically if we can
      button.disabled = true;
      button.style.opacity = "0.5";
      button.style.cursor = "not-allowed";
      button.classList.add('disabled-option');
      console.log(`Fixed: Disabled ${processingType} button`);
    }
    
    // Verify 120 film restrictions
    if (normalizedFilmType === "120") {
      if (processingType && (processingType.includes("E-6") || processingType.includes("ECN-2"))) {
        console.assert(isDisabled, `ERROR: ${processingType} should be disabled for 120 film but isn't`);
        if (!isDisabled) {
          // Fix it automatically
          button.disabled = true;
          button.style.opacity = "0.4";
          button.style.cursor = "not-allowed";
          button.classList.add('disabled-option');
          console.log(`Fixed: Disabled ${processingType} button for 120 film`);
        }
      } else if (processingType) {
        console.assert(!isDisabled, `ERROR: ${processingType} should be enabled for 120 film but isn't`);
        if (isDisabled) {
          // Fix it automatically
          button.disabled = false;
          button.style.opacity = "1";
          button.style.cursor = "pointer";
          button.classList.remove('disabled-option');
          console.log(`Fixed: Enabled ${processingType} button for 120 film`);
        }
      }
    }
  });
  
  console.log("Verification complete");
}

// Add the verification call to the nextStep function
const originalNextStep = nextStep;
nextStep = function(currentStepNumber, choice) {
  originalNextStep(currentStepNumber, choice);
  
  // Run verification after processing type step is activated
  if (currentStep === 2) {
    setTimeout(verifyProcessingTypeAvailability, 100);
  }
};
